/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PathLocaleImport } from './routes/$pathLocale'
import { Route as IndexImport } from './routes/index'
import { Route as PathLocaleMedicalHistoryImport } from './routes/$pathLocale/medical-history'
import { Route as PathLocaleLayoutImport } from './routes/$pathLocale/_layout'
import { Route as PathLocaleGuestImport } from './routes/$pathLocale/_guest'
import { Route as PathLocaleLayoutAuthImport } from './routes/$pathLocale/_layout/_auth'
import { Route as PathLocaleGuestAcceptInviteImport } from './routes/$pathLocale/_guest/accept-invite'
import { Route as PathLocaleLayoutAuthIndexImport } from './routes/$pathLocale/_layout/_auth/index'
import { Route as PathLocaleLayoutAuthCompleteProfileImport } from './routes/$pathLocale/_layout/_auth/complete-profile'
import { Route as PathLocaleGuestSignUpSplatImport } from './routes/$pathLocale/_guest/sign-up.$'
import { Route as PathLocaleGuestSignInSplatImport } from './routes/$pathLocale/_guest/sign-in.$'

// Create/Update Routes

const PathLocaleRoute = PathLocaleImport.update({
  id: '/$pathLocale',
  path: '/$pathLocale',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PathLocaleMedicalHistoryRoute = PathLocaleMedicalHistoryImport.update({
  id: '/medical-history',
  path: '/medical-history',
  getParentRoute: () => PathLocaleRoute,
} as any)

const PathLocaleLayoutRoute = PathLocaleLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => PathLocaleRoute,
} as any)

const PathLocaleGuestRoute = PathLocaleGuestImport.update({
  id: '/_guest',
  getParentRoute: () => PathLocaleRoute,
} as any)

const PathLocaleLayoutAuthRoute = PathLocaleLayoutAuthImport.update({
  id: '/_auth',
  getParentRoute: () => PathLocaleLayoutRoute,
} as any)

const PathLocaleGuestAcceptInviteRoute =
  PathLocaleGuestAcceptInviteImport.update({
    id: '/accept-invite',
    path: '/accept-invite',
    getParentRoute: () => PathLocaleGuestRoute,
  } as any)

const PathLocaleLayoutAuthIndexRoute = PathLocaleLayoutAuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PathLocaleLayoutAuthRoute,
} as any)

const PathLocaleLayoutAuthCompleteProfileRoute =
  PathLocaleLayoutAuthCompleteProfileImport.update({
    id: '/complete-profile',
    path: '/complete-profile',
    getParentRoute: () => PathLocaleLayoutAuthRoute,
  } as any)

const PathLocaleGuestSignUpSplatRoute = PathLocaleGuestSignUpSplatImport.update(
  {
    id: '/sign-up/$',
    path: '/sign-up/$',
    getParentRoute: () => PathLocaleGuestRoute,
  } as any,
)

const PathLocaleGuestSignInSplatRoute = PathLocaleGuestSignInSplatImport.update(
  {
    id: '/sign-in/$',
    path: '/sign-in/$',
    getParentRoute: () => PathLocaleGuestRoute,
  } as any,
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$pathLocale': {
      id: '/$pathLocale'
      path: '/$pathLocale'
      fullPath: '/$pathLocale'
      preLoaderRoute: typeof PathLocaleImport
      parentRoute: typeof rootRoute
    }
    '/$pathLocale/_guest': {
      id: '/$pathLocale/_guest'
      path: ''
      fullPath: '/$pathLocale'
      preLoaderRoute: typeof PathLocaleGuestImport
      parentRoute: typeof PathLocaleImport
    }
    '/$pathLocale/_layout': {
      id: '/$pathLocale/_layout'
      path: ''
      fullPath: '/$pathLocale'
      preLoaderRoute: typeof PathLocaleLayoutImport
      parentRoute: typeof PathLocaleImport
    }
    '/$pathLocale/medical-history': {
      id: '/$pathLocale/medical-history'
      path: '/medical-history'
      fullPath: '/$pathLocale/medical-history'
      preLoaderRoute: typeof PathLocaleMedicalHistoryImport
      parentRoute: typeof PathLocaleImport
    }
    '/$pathLocale/_guest/accept-invite': {
      id: '/$pathLocale/_guest/accept-invite'
      path: '/accept-invite'
      fullPath: '/$pathLocale/accept-invite'
      preLoaderRoute: typeof PathLocaleGuestAcceptInviteImport
      parentRoute: typeof PathLocaleGuestImport
    }
    '/$pathLocale/_layout/_auth': {
      id: '/$pathLocale/_layout/_auth'
      path: ''
      fullPath: '/$pathLocale'
      preLoaderRoute: typeof PathLocaleLayoutAuthImport
      parentRoute: typeof PathLocaleLayoutImport
    }
    '/$pathLocale/_guest/sign-in/$': {
      id: '/$pathLocale/_guest/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/$pathLocale/sign-in/$'
      preLoaderRoute: typeof PathLocaleGuestSignInSplatImport
      parentRoute: typeof PathLocaleGuestImport
    }
    '/$pathLocale/_guest/sign-up/$': {
      id: '/$pathLocale/_guest/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/$pathLocale/sign-up/$'
      preLoaderRoute: typeof PathLocaleGuestSignUpSplatImport
      parentRoute: typeof PathLocaleGuestImport
    }
    '/$pathLocale/_layout/_auth/complete-profile': {
      id: '/$pathLocale/_layout/_auth/complete-profile'
      path: '/complete-profile'
      fullPath: '/$pathLocale/complete-profile'
      preLoaderRoute: typeof PathLocaleLayoutAuthCompleteProfileImport
      parentRoute: typeof PathLocaleLayoutAuthImport
    }
    '/$pathLocale/_layout/_auth/': {
      id: '/$pathLocale/_layout/_auth/'
      path: '/'
      fullPath: '/$pathLocale/'
      preLoaderRoute: typeof PathLocaleLayoutAuthIndexImport
      parentRoute: typeof PathLocaleLayoutAuthImport
    }
  }
}

// Create and export the route tree

interface PathLocaleGuestRouteChildren {
  PathLocaleGuestAcceptInviteRoute: typeof PathLocaleGuestAcceptInviteRoute
  PathLocaleGuestSignInSplatRoute: typeof PathLocaleGuestSignInSplatRoute
  PathLocaleGuestSignUpSplatRoute: typeof PathLocaleGuestSignUpSplatRoute
}

const PathLocaleGuestRouteChildren: PathLocaleGuestRouteChildren = {
  PathLocaleGuestAcceptInviteRoute: PathLocaleGuestAcceptInviteRoute,
  PathLocaleGuestSignInSplatRoute: PathLocaleGuestSignInSplatRoute,
  PathLocaleGuestSignUpSplatRoute: PathLocaleGuestSignUpSplatRoute,
}

const PathLocaleGuestRouteWithChildren = PathLocaleGuestRoute._addFileChildren(
  PathLocaleGuestRouteChildren,
)

interface PathLocaleLayoutAuthRouteChildren {
  PathLocaleLayoutAuthCompleteProfileRoute: typeof PathLocaleLayoutAuthCompleteProfileRoute
  PathLocaleLayoutAuthIndexRoute: typeof PathLocaleLayoutAuthIndexRoute
}

const PathLocaleLayoutAuthRouteChildren: PathLocaleLayoutAuthRouteChildren = {
  PathLocaleLayoutAuthCompleteProfileRoute:
    PathLocaleLayoutAuthCompleteProfileRoute,
  PathLocaleLayoutAuthIndexRoute: PathLocaleLayoutAuthIndexRoute,
}

const PathLocaleLayoutAuthRouteWithChildren =
  PathLocaleLayoutAuthRoute._addFileChildren(PathLocaleLayoutAuthRouteChildren)

interface PathLocaleLayoutRouteChildren {
  PathLocaleLayoutAuthRoute: typeof PathLocaleLayoutAuthRouteWithChildren
}

const PathLocaleLayoutRouteChildren: PathLocaleLayoutRouteChildren = {
  PathLocaleLayoutAuthRoute: PathLocaleLayoutAuthRouteWithChildren,
}

const PathLocaleLayoutRouteWithChildren =
  PathLocaleLayoutRoute._addFileChildren(PathLocaleLayoutRouteChildren)

interface PathLocaleRouteChildren {
  PathLocaleGuestRoute: typeof PathLocaleGuestRouteWithChildren
  PathLocaleLayoutRoute: typeof PathLocaleLayoutRouteWithChildren
  PathLocaleMedicalHistoryRoute: typeof PathLocaleMedicalHistoryRoute
}

const PathLocaleRouteChildren: PathLocaleRouteChildren = {
  PathLocaleGuestRoute: PathLocaleGuestRouteWithChildren,
  PathLocaleLayoutRoute: PathLocaleLayoutRouteWithChildren,
  PathLocaleMedicalHistoryRoute: PathLocaleMedicalHistoryRoute,
}

const PathLocaleRouteWithChildren = PathLocaleRoute._addFileChildren(
  PathLocaleRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$pathLocale': typeof PathLocaleLayoutAuthRouteWithChildren
  '/$pathLocale/medical-history': typeof PathLocaleMedicalHistoryRoute
  '/$pathLocale/accept-invite': typeof PathLocaleGuestAcceptInviteRoute
  '/$pathLocale/sign-in/$': typeof PathLocaleGuestSignInSplatRoute
  '/$pathLocale/sign-up/$': typeof PathLocaleGuestSignUpSplatRoute
  '/$pathLocale/complete-profile': typeof PathLocaleLayoutAuthCompleteProfileRoute
  '/$pathLocale/': typeof PathLocaleLayoutAuthIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$pathLocale': typeof PathLocaleLayoutAuthIndexRoute
  '/$pathLocale/medical-history': typeof PathLocaleMedicalHistoryRoute
  '/$pathLocale/accept-invite': typeof PathLocaleGuestAcceptInviteRoute
  '/$pathLocale/sign-in/$': typeof PathLocaleGuestSignInSplatRoute
  '/$pathLocale/sign-up/$': typeof PathLocaleGuestSignUpSplatRoute
  '/$pathLocale/complete-profile': typeof PathLocaleLayoutAuthCompleteProfileRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/$pathLocale': typeof PathLocaleRouteWithChildren
  '/$pathLocale/_guest': typeof PathLocaleGuestRouteWithChildren
  '/$pathLocale/_layout': typeof PathLocaleLayoutRouteWithChildren
  '/$pathLocale/medical-history': typeof PathLocaleMedicalHistoryRoute
  '/$pathLocale/_guest/accept-invite': typeof PathLocaleGuestAcceptInviteRoute
  '/$pathLocale/_layout/_auth': typeof PathLocaleLayoutAuthRouteWithChildren
  '/$pathLocale/_guest/sign-in/$': typeof PathLocaleGuestSignInSplatRoute
  '/$pathLocale/_guest/sign-up/$': typeof PathLocaleGuestSignUpSplatRoute
  '/$pathLocale/_layout/_auth/complete-profile': typeof PathLocaleLayoutAuthCompleteProfileRoute
  '/$pathLocale/_layout/_auth/': typeof PathLocaleLayoutAuthIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$pathLocale'
    | '/$pathLocale/medical-history'
    | '/$pathLocale/accept-invite'
    | '/$pathLocale/sign-in/$'
    | '/$pathLocale/sign-up/$'
    | '/$pathLocale/complete-profile'
    | '/$pathLocale/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$pathLocale'
    | '/$pathLocale/medical-history'
    | '/$pathLocale/accept-invite'
    | '/$pathLocale/sign-in/$'
    | '/$pathLocale/sign-up/$'
    | '/$pathLocale/complete-profile'
  id:
    | '__root__'
    | '/'
    | '/$pathLocale'
    | '/$pathLocale/_guest'
    | '/$pathLocale/_layout'
    | '/$pathLocale/medical-history'
    | '/$pathLocale/_guest/accept-invite'
    | '/$pathLocale/_layout/_auth'
    | '/$pathLocale/_guest/sign-in/$'
    | '/$pathLocale/_guest/sign-up/$'
    | '/$pathLocale/_layout/_auth/complete-profile'
    | '/$pathLocale/_layout/_auth/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PathLocaleRoute: typeof PathLocaleRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PathLocaleRoute: PathLocaleRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/$pathLocale"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/$pathLocale": {
      "filePath": "$pathLocale.tsx",
      "children": [
        "/$pathLocale/_guest",
        "/$pathLocale/_layout",
        "/$pathLocale/medical-history"
      ]
    },
    "/$pathLocale/_guest": {
      "filePath": "$pathLocale/_guest.tsx",
      "parent": "/$pathLocale",
      "children": [
        "/$pathLocale/_guest/accept-invite",
        "/$pathLocale/_guest/sign-in/$",
        "/$pathLocale/_guest/sign-up/$"
      ]
    },
    "/$pathLocale/_layout": {
      "filePath": "$pathLocale/_layout.tsx",
      "parent": "/$pathLocale",
      "children": [
        "/$pathLocale/_layout/_auth"
      ]
    },
    "/$pathLocale/medical-history": {
      "filePath": "$pathLocale/medical-history.tsx",
      "parent": "/$pathLocale"
    },
    "/$pathLocale/_guest/accept-invite": {
      "filePath": "$pathLocale/_guest/accept-invite.tsx",
      "parent": "/$pathLocale/_guest"
    },
    "/$pathLocale/_layout/_auth": {
      "filePath": "$pathLocale/_layout/_auth.tsx",
      "parent": "/$pathLocale/_layout",
      "children": [
        "/$pathLocale/_layout/_auth/complete-profile",
        "/$pathLocale/_layout/_auth/"
      ]
    },
    "/$pathLocale/_guest/sign-in/$": {
      "filePath": "$pathLocale/_guest/sign-in.$.tsx",
      "parent": "/$pathLocale/_guest"
    },
    "/$pathLocale/_guest/sign-up/$": {
      "filePath": "$pathLocale/_guest/sign-up.$.tsx",
      "parent": "/$pathLocale/_guest"
    },
    "/$pathLocale/_layout/_auth/complete-profile": {
      "filePath": "$pathLocale/_layout/_auth/complete-profile.tsx",
      "parent": "/$pathLocale/_layout/_auth"
    },
    "/$pathLocale/_layout/_auth/": {
      "filePath": "$pathLocale/_layout/_auth/index.tsx",
      "parent": "/$pathLocale/_layout/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
